module.exports = {"321322001":"沭城街道","321322002":"南湖街道","321322003":"梦溪街道","321322004":"十字街道","321322005":"章集街道","321322006":"七雄街道","321322101":"陇集镇","321322102":"胡集镇","321322103":"钱集镇","321322104":"塘沟镇","321322105":"马厂镇","321322106":"沂涛镇","321322107":"庙头镇","321322108":"韩山镇","321322109":"华冲镇","321322110":"桑墟镇","321322111":"悦来镇","321322112":"刘集镇","321322114":"李恒镇","321322115":"扎下镇","321322116":"颜集镇","321322117":"潼阳镇","321322118":"龙庙镇","321322119":"高墟镇","321322120":"耿圩镇","321322124":"新河镇","321322125":"贤官镇","321322126":"吴集镇","321322128":"青伊湖镇","321322205":"西圩乡","321322401":"沭阳经济开发区","321322402":"昆山（沭阳）工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/321322.json
// module id = 1037
// module chunks = 0